module.exports = __webpack_public_path__ + "img/spins_9.c05452ac.png";